import { Injectable } from '@angular/core';
import { FornitoriAdmin } from 'src/app/models/supplier-portal/supplier/fornitori-admin.models';

export interface TraceSearchState {
  searchTerm: string;
  startDate: Date | null;
  endDate: Date | null;
  results: FornitoriAdmin.TraceSearchResult[];
  searched: boolean;
  searchError: boolean;
}

@Injectable({
  providedIn: 'root',
})


export class TraceSearchStateService {

  private state: TraceSearchState = {
    searchTerm: '',
    startDate: null,
    endDate: null,
    results: [],
    searched: false,
    searchError: false,
  };

  getState(): TraceSearchState {
    return this.state;
  }

  setState(state: Partial<TraceSearchState>): void {
    this.state = {
      ...this.state,
      ...state,
    };
  }

  clear(): void {
    this.state = {
      searchTerm: '',
      startDate: null,
      endDate: null,
      results: [],
      searched: false,
      searchError: false,
    };
  }
  
}